import { getCintButtonStyles, getDefaultButtonStyles } from './styles';
// Selector to resolve the correct button styles per theme
export var selectButtonStyles = function (props) {
    var _a;
    switch ((_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.template) {
        case 'LUCID':
            return getDefaultButtonStyles(props);
        case 'CINT':
            return getCintButtonStyles(props);
        default:
            return getDefaultButtonStyles(props);
    }
};
//# sourceMappingURL=buttonStyles.js.map